export default __webpack_public_path__ + "static/media/lightbulb-flash-line.4dbee6a6.svg";